import * as React from "react";
import {Box, ToggleButton, ToggleButtonGroup, Grid} from "@mui/material";
import {useQueryGatherProduct, useQueryGatherWriterTime, useQueryGatherWriting} from "@/service/analyze";
import Last12mProduct from "@/pages/Analyze/Mission/Recent12mProduct";
import WriteStatusDist from "@/pages/Analyze/Mission/WriteStatusDist";
import TotalSummary from "@/pages/Analyze/Mission/TotalSummary";
import SellerProductRanking from "@/pages/Analyze/Mission/SellerProductRanking";
import WriterCategoryRanking from "@/pages/Analyze/Mission/WriterCategoryRanking";
import WriteStatusAmount from "@/pages/Analyze/Mission/WriteStatusAmount";
import {useMemo, useState} from "react";
import {OptionType} from "@/model/global";
import {useAuthInfo} from "@/store/account.c";
import {filter, get} from "lodash";

const options: OptionType[] = [
    {label: "项目", value: 1},
    {label: "专利", value: 2},
    {label: "商标", value: 3},
    {label: "版权", value: 4},
]

export default function AnalyzePage() {
    const [option, setOption] = useState<OptionType>({value: 1, label: "项目"})
    const {data: gatherWritingData, isPending: gatherWritingPending} = useQueryGatherWriting()
    const {data: gatherProductData, isPending: gatherProductPending} = useQueryGatherProduct()
    const {data: gatherWriterTimeData, isPending: gatherWriterTimePending} = useQueryGatherWriterTime()
    const gatherWriting = gatherWritingData?.data
    const gatherProduct = gatherProductData?.data
    const gatherWriterTime = gatherWriterTimeData?.data
    const {role} = useAuthInfo()

    const filterOptions = useMemo(() => {
        let filterOptions: OptionType[] = options
        if (role?.roleAlias == "declarer") {
            filterOptions = filter(options, item => item.value == 1)
        } else if (role?.roleAlias == "patenter") {
            filterOptions = filter(options, item => item.value == 2)
        } else if (role?.roleAlias == "processer") {
            filterOptions = filter(options, item => item.value != 1)
        }
        setOption(get(filterOptions, '[0]', {label: "", value: 0}))
        return filterOptions;
    }, [role])

    return (
        <Box sx={{width: "100%", maxWidth: {sm: "100%", md: "1700px"}}}>
            <Grid
                container
                spacing={2}
                columns={12}
            >
                <Grid size={{xs: 12, sm: 6, lg: 3.9}}>
                    <TotalSummary option={option}/>
                </Grid>
                <Grid size={{xs: 12, sm: 6, lg: 8.1}}>
                    <WriteStatusAmount option={option}
                                       writeCopyrightStatus={gatherWriting?.writeCopyrightStatus}
                                       writePatentStatus={gatherWriting?.writePatentStatus}
                                       writeTrademarkStatus={gatherWriting?.writeTrademarkStatus}
                                       writeProjectStatus={gatherWriting?.writeProjectStatus}/>
                </Grid>
                <Grid size={{xs: 12, sm: 6, lg: 6}}>
                    <SellerProductRanking loading={gatherProductPending} option={option}
                                          top10PatentClas={gatherProduct?.top10PatentClas || []}
                                          top10TrademarkClas={gatherProduct?.top10TrademarkClas || []}
                                          top10CopyrightClas={gatherProduct?.top10CopyrightClas || []}
                                          top10ProjectClas={gatherProduct?.top10ProjectClas || []}/>
                </Grid>
                <Grid size={{xs: 12, sm: 6, lg: 6}}>
                    <WriteStatusDist loading={gatherWritingPending} option={option}
                                     writeCopyrightStatus={gatherWriting?.writeCopyrightStatus || []}
                                     writePatentStatus={gatherWriting?.writePatentStatus || []}
                                     writeTrademarkStatus={gatherWriting?.writeTrademarkStatus || []}
                                     writeProjectStatus={gatherWriting?.writeProjectStatus || []}/>
                </Grid>
                <Grid size={{xs: 12, sm: 6, lg: 6}}>
                    <Last12mProduct loading={gatherWriterTimePending} {...gatherWriterTime} option={option}/>
                </Grid>
                <Grid size={{xs: 12, sm: 6, lg: 6}}>
                    <WriterCategoryRanking loading={gatherProductPending} option={option}
                                           top5CopyrightWriter={gatherProduct?.top5CopyrightWriter || []}
                                           top5TrademarkWriter={gatherProduct?.top5TrademarkWriter || []}
                                           top5PatentWriter={gatherProduct?.top5PatentWriter || []}
                                           top5ProjectWriter={gatherProduct?.top5ProjectWriter || []}/>
                </Grid>
            </Grid>
            {filterOptions?.length > 1 && <ToggleButtonGroup
                orientation="vertical"
                value={option}
                exclusive={true}
                onChange={(event, value) => value && setOption(value)}
                sx={{position: 'fixed', right: 14, bottom: '6%', zIndex: 9999, backgroundColor: '#fff'}}>
                {
                    filterOptions.map((option, index) => <ToggleButton key={index} size={'small'} value={option}>
                        {option.label}
                    </ToggleButton>)}
            </ToggleButtonGroup>
            }

        </Box>
    )
        ;
}
